module.exports = __webpack_public_path__ + "img/039.ae320ec9.jpg";